<template>
	<component :is="this.context || 'div'"></component>
</template>

<script>
import LocumDashboardLandingZone from '@/components/ui/dashboard/locum/LocumDashboardLandingZone';
// import LocumLocationCard from '@/components/ui/dashboard/locum/cards/LocumLocationCard';
import LocumOffersBasedOnLocation from '@/components/ui/dashboard/locum/dropdowns/LocumOffersBasedOnLocation';
import LocumSetAvailability from '@/components/ui/dashboard/locum/cards/LocumSetAvailability';
// import LocumPracticeSearchResults from '@/components/ui/dashboard/locum/cards/LocumPracticeSearchResults';
// import LocumPracticeProfile from '@/components/ui/dashboard/locum/cards/LocumPracticeProfile';
// import LocumCreateOffer from '@/components/ui/dashboard/locum/cards/LocumCreateOffer';
// import LocumToPracticeBookingRequestSent from '@/components/ui/dashboard/locum/cards/LocumToPracticeBookingRequestSent';
import LocumAvailabilitySet from '@/components/ui/dashboard/locum/cards/LocumAvailabilitySet';
// import LocumToPracticeMakeBooking from '@/components/ui/dashboard/locum/cards/LocumToPracticeMakeBooking';

import LocumViewHistoricalBooking from '@/components/ui/dashboard/locum/cards/LocumViewHistoricalBooking';
import ViewPracticeDetailsCard from '@/components/ui/dashboard/locum/cards/ViewPracticeDetailsCard';
import LocumApplicationSent from '@/components/ui/dashboard/locum/cards/LocumApplicationSent';

import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';
//SUCCESS
import LocumSuccessApplicationSent from '@/components/ui/dashboard/locum/cards/LocumSuccessApplicationSent';
import LocumSuccessAvailabilitySet from '@/components/ui/dashboard/locum/cards/LocumSuccessAvailabilitySet';
import LocumSuccessBookingConfirmed from '@/components/ui/dashboard/locum/cards/LocumSuccessBookingConfirmed';
import LocumSuccessBookingRejected from '@/components/ui/dashboard/locum/cards/LocumSuccessBookingRejected';

import LocumSuccessAvailabilityDeleted from '@/components/ui/dashboard/locum/cards/LocumSuccessAvailabilityDeleted';

import { bus } from '@/main';

export default {
	name: 'LocumDashboardMain',
	components: {
		// LocumLocationCard,
		LocumOffersBasedOnLocation,
		LocumDashboardLandingZone,
		LocumSetAvailability,
		LocumAvailabilitySet,
		// LocumPracticeSearchResults,
		// LocumPracticeProfile,
		// LocumCreateOffer,
		ViewPracticeDetailsCard,
		LocumViewHistoricalBooking,

		LocumApplicationSent,

		// LocumToPracticeBookingRequestSent,
		// LocumToPracticeMakeBooking,
		LocumIncreaseAvailabilityAd,

		//success zones
		LocumSuccessApplicationSent,
		LocumSuccessAvailabilitySet,
		LocumSuccessBookingConfirmed,
		LocumSuccessBookingRejected,

		LocumSuccessAvailabilityDeleted,
	},
	data: () => ({
		context: 'locum-dashboard-landing-zone',
	}),
	created() {
		bus.$on('change-context', new_context => {
			this.context = new_context;
		});
	},
	beforeDestroy() {},
	methods: {},
};
</script>
